/* import __COLOCATED_TEMPLATE__ from './agent-type-icon.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
//@ts-ignore
import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
import { AGENT_TYPE_CONFIG, DEFAULT_AGENT_TYPE } from 'embercom/lib/ai-agent/agent-type-config';
import type { AgentTypeValue } from 'embercom/lib/ai-agent/agent-type-config';

interface Arguments {
  agentType?: string;
  size?: 'small';
}

interface Signature {
  Element: HTMLDivElement;
  Args: Arguments;
}

export default class AgentTypeIcon extends Component<Signature> {
  get config() {
    let agentType = (this.args.agentType ?? DEFAULT_AGENT_TYPE) as AgentTypeValue;
    return AGENT_TYPE_CONFIG[agentType] ?? AGENT_TYPE_CONFIG[DEFAULT_AGENT_TYPE];
  }

  get iconName() {
    return this.config.icon;
  }

  get containerStyle() {
    let style = `background-color: ${this.config.color}; color: #fff`;
    if (this.args.size !== 'small') {
      style += '; outline: 3px solid var(--base-module)';
    }
    return sanitizeHtml(style);
  }

  get iconScale(): string | undefined {
    if (this.args.size === 'small') {
      return undefined;
    }
    return this.config.iconScale;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::AgentTypeIcon': typeof AgentTypeIcon;
    'ai-agent/agent-type-icon': typeof AgentTypeIcon;
  }
}
